<template>
    <div 
        class="calendar-item"
        @click.stop.prevent="$emit('openTaskDetailSidebar', taskValue)"
    >
        <div class="task-row">
            <div class="task-checkbox">
                <div 
                    class="status-square"
                    :style="{ backgroundColor: statusColor }"
                ></div>
            </div>

            <div class="task-title">
                <img 
                    v-if="!taskValue.isParentTask" 
                    :src="subtaskIcon" 
                    class="subtask-icon"
                    alt="subtask"
                />
                <span class="task-name" :title="taskValue.TaskName">
                    {{ taskValue.TaskName }}
                </span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { defineProps, ref, computed, defineEmits } from "vue";
import { useStore } from 'vuex';

const { getters } = useStore();
const TaskStatusArray = computed(() => getters["settings/AllTaskStatus"]);

const props = defineProps({
    taskObject: {
        type: Object,
        required: true
    },
    findParticularProject: {
        type: Object,
        default: () => {}
    },
});

defineEmits(['openTaskDetailSidebar']);

const taskValue = ref(props.taskObject);
const subtaskIcon = require('@/assets/images/svg/subtaskicon.svg');

const statusColor = computed(() => {
    const statusArray = TaskStatusArray.value?.settings || [];
    const status = statusArray.find((s) => s.key === taskValue.value.statusKey);
    return status?.textColor || '#8e8e93';
});
</script>

<style scoped>
.calendar-item {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 2px 0;
    cursor: pointer;
    border-radius: 4px;
    transition: background-color 0.15s ease;
}

.calendar-item:hover {
    background-color: rgba(0, 0, 0, 0.03);
}

.task-row {
    align-self: stretch;
    display: flex;
    align-items: center;
    gap: 6px;
}

.task-checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px;
    flex-shrink: 0;
}

.status-square {
    width: 10px;
    height: 10px;
    border-radius: 2px;
    background-color: #8e8e93;
}

.task-title {
    height: 24px;
    display: flex;
    align-items: center;
    gap: 4px;
    flex: 1;
    min-width: 0;
}

.subtask-icon {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
}

.task-name {
    font-family: Inter, sans-serif;
    font-size: 12px;
    line-height: 18px;
    color: #141414;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>